import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getFromLocale, getSiteInfo } from "@/utils";

const { lang, curr, siteName } = getSiteInfo()??{}

export const startupApi = createApi({
  reducerPath: "startupApis",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.API_URL}/api`,
    prepareHeaders: (headers) => {
      headers.set("Authorization", `Bearer ${getFromLocale()}`);
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("Currency", `${curr}`);
      headers.set("Language", `${lang}`);
      headers.set("Referrer", siteName);
      return headers;
    },
  }),
  tagTypes: ["startup", "startup-details", "joinTeamStartup"],
  endpoints: (builder) => ({
    getStartupList: builder.query({
      query: (page) => `/startup?page=${page}`,
      providesTags: ["startup"],
    }),
    getStartupById: builder.query({
      query: (slug) => `/startup/${slug}`,
      providesTags: ["startup-details"],
    }),
    joinTeamStartup: builder.mutation({
      query: (startup) => ({
        url: "/startup-application",
        method: "POST",
        body: startup,
      }),
      invalidatesTags: ["joinTeamStartup"],
    }),
  }),
});
export const {
  useLazyGetStartupListQuery,
  useGetStartupByIdQuery,
  useJoinTeamStartupMutation,
} = startupApi;
